<template>
	<div class="service-page" v-loading="loading">
		<div class="box">
			<div class="new" @click="handleExcel">
				<div class="i iconfont icon-xiazai"></div>
				<div>导入</div>
			</div>
			<div class="new" @click="download('model')">
				<div class="iconfont icon-xiazai"></div>
				<div>下载导入模板</div>
			</div>
			<input class="input-file" ref="fileInt" style="display: none" type="file" @change="excelInput"
				accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
		</div>
		<div v-if="tableData.length">
			<div class="head"></div>
			<div class="content">
				<div class="content-name">
					<div>导入时间</div>
					<div class="content-name-name" v-for="item in tableData">{{ item.createTime }}</div>
				</div>
				<div class="content-name status">
					<div>状态</div>
					<div class="content-name-name" v-for="item in tableData">
						<div v-if="item.status == 0">比价数据生成中</div>
						<div v-else-if="item.status == 1">已完成</div>
						<div v-else-if="item.status == 2">失败</div>
						<div v-else-if="item.status == 3">过期</div>
					</div>
				</div>
				<div class="content-name status">
					<div>操作</div>
					<div class="content-name-name" :class="{download:item.status == 1}" v-for="item in tableData">
						<div v-if="item.status == 1" @click="download(item.ftpUrl)">下载</div>
						<div v-else>-</div>
					</div>
				</div>
			</div>
		</div>
		<el-empty v-else description="暂无导入记录"></el-empty>
	</div>
</template>


<script>
	import * as XLSX from 'xlsx'
	import {
		commodityParity,
		getDownloadList
	} from "@/api/mycenter";
	export default {
		name: "comparePrice",
		data() {
			return {
				tableData: [],
				loading: false,
				current: 1,
			}
		},
		mounted() {
			this.getDownloadList()
		},
		beforeDestroy() {
			if(this.tid) clearTimeout(this.tid);
		},
		methods: {
			/*
			 * 2025-01-03 刘晓茜
			 * 点击导入
			 * */
			handleExcel() {
				document.querySelector(".input-file").click();
			},
			/*
			 * 2025-01-03 刘晓茜
			 * 读取Excel数据
			 * */
			excelInput(event) {
				if (event.currentTarget == null || !event.currentTarget.files.length) {
					this.$message.error("导入失败");
					return;
				}
				const that = this;
				// 拿取文件对象
				let f = event.currentTarget.files[0];
				// 用FileReader来读取
				let reader = new FileReader();
				// 重写FileReader上的readAsBinaryString方法
				FileReader.prototype.readAsBinaryString = function(f) {
					let binary = "";
					let wb; // 读取完成的数据
					let outdata; // 你需要的数据
					let reader = new FileReader();
					reader.onload = function(e) {
						// 读取成Uint8Array，再转换为Unicode编码（Unicode占两个字节）
						let bytes = new Uint8Array(reader.result);
						let length = bytes.byteLength;
						for (let i = 0; i < length; i++) {
							binary += String.fromCharCode(bytes[i]);
						}
						// 接下来就是xlsx了，具体可看api
						wb = XLSX.read(binary, {
							type: "binary",
						});
						outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
						// 自定义方法向父组件传递数据
						let changeList = [];
						if (outdata && outdata.length > 0) {
							for (let i = 0; i < outdata.length; i++) {
								changeList.push(outdata[i]['商品货号']);
							}
							that.$refs.fileInt.value = "";
							that.drugAddByExcel(changeList);
						} else {
							that.$refs.fileInt.value = "";
							that.$message.error("商品信息为空");
						}
					};
					reader.readAsArrayBuffer(f);
				};
				reader.readAsBinaryString(f);
			},
			/*
			 * 2025-01-03 刘晓茜
			 * 将Excel数据传入接口
			 * */
			drugAddByExcel(changeList) {
				this.loading = true;
				commodityParity({
					"productTypeCodeList": changeList
				}).then((response) => {
					this.loading = false;
					if (response && response.code === "0" && response.data) {
						this.$message({
							message: "操作成功",
							type: "success",
						});
						this.getDownloadList();
					} else if (response && response.status !== "0") {
						this.$message.error(response.msg);
					} else {
						this.$message.error("操作失败");
					}
				});
			},
			/**
			 * 2025-01-03 刘晓茜
			 * 获取下载列表
			 * */
			getDownloadList() {
				this.isLoading = true;
				getDownloadList().then((res) => {
					this.isLoading = false;
					if (res.code == 0 && res.data) {
						this.tableData = res.data.reverse();
						if(this.tid) clearTimeout(this.tid);
						if (this.tableData.filter(item => item.status == 0).length) {
							this.tid = setTimeout(() => {
								this.getDownloadList();
							}, 10000)
						}
					} else {
						this.$message.error("加载列表失败");
					}
				});
			},
			/**
			 * 2024-12-30 刘晓茜
			 * 下载
			 */
			download(ftpUrl) {
				let url = ftpUrl == 'model' ? "https://syjk-oss.sypmyoulecai.com/syjk-purchase/template/商品比价模版.xlsx" :
					ftpUrl;
				window.open(url);
			}
		}
	}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
	@import "@/assets/css/szui.scss";

	.service-page {
		padding: 16px 20px 30px;
		background: #FFFFFF;
		border-radius: 8px;

		.box {
			display: flex;
			justify-content: space-between;
			margin-bottom: 20px;

			.new {
				height: 30px;
				background: #F8F8F8;
				border: 1px solid #C0C4CC;
				border-radius: 5px;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
				padding: 10px;
				font-size: 14px;
				font-weight: 400;
				color: $fontColor;
				line-height: 17px;

				.i {
					transform: rotate(90deg);
				}

				.iconfont {
					margin-right: 5px;
					font-size: 12px;
				}
			}

		}

		.head {
			height: 42px;
			background: #F5F7FA;
			border: 1px solid #EDEFF2;
			border-radius: 10px;
		}

		.content {
			display: flex;
			justify-content: space-between;
			margin-top: -30px;

			.content-name {
				display: flex;
				align-items: flex-start;
				justify-content: center;
				flex-direction: column;
				font-size: 14px;
				font-weight: 400;
				color: #262728;
				margin: 0 20px;

				.content-name-name {
					margin-top: 40px;
					font-size: 14px;
					font-weight: 400;
					color: #262728;
				}

				.download {
					color: #005EB1;
					cursor: pointer;

				}

				.download:hover {
					text-decoration: underline;
				}
			}

			.status {
				align-items: center;
			}
		}

		.paging {
			text-align: center;
			margin-top: 34px;


			.el-pagination {
				.btn-prev {
					background-color: #f8f8f8;
				}

				.el-pager li {
					min-width: 28px;
					background-color: #f8f8f8;
				}

				.el-pager {
					.active {
						color: #000;
						box-sizing: border-box;
						border-radius: 8px;
						background-color: $main;
					}
				}

				.btn-next {
					background-color: #f8f8f8;
				}
			}
		}

	}
</style>